import React from "react";
import "../sass/landing/footer.scss";
import Marca from "../assets/landing/marca-clara.webp";
import { scrollToSection } from "./landing/scroll";

const CONTACT_EMAIL = "contato@psyassist.com.br";
const SECTIONS = [
  { id: "beneficios", label: "Como ajuda" },
  { id: "como-funciona", label: "Dia a dia" },
  { id: "planos", label: "Planos" },
  { id: "faq", label: "Dúvidas" },
  { id: "parcerias", label: "Parcerias" },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const goTo = (event, id) => {
    event.preventDefault();
    scrollToSection(id);
  };

  return (
    <footer className="lp-footer">
      <div className="lp-shell">
        <div className="lp-footer__top">
          <div className="lp-footer__brand">
            <a
              href="#hero"
              className="lp-footer__logo"
              onClick={(event) => goTo(event, "hero")}
              aria-label="PsyAssist Pro, voltar ao início"
            >
              <img src={Marca} alt="" width="40" height="40" />
              <span>PsyAssist <em>Pro</em></span>
            </a>
            <p>
              Para o psicólogo que atende por conta própria e ainda cuida da
              agenda, das cobranças e dos registros.
            </p>
            <a className="lp-footer__mail" href={`mailto:${CONTACT_EMAIL}`}>
              {CONTACT_EMAIL}
            </a>
          </div>

          <nav className="lp-footer__columns" aria-label="Links do rodapé">
            <div>
              <h2>PsyAssist</h2>
              <ul>
                {SECTIONS.map((section) => (
                  <li key={section.id}>
                    <a href={`/#${section.id}`} onClick={(event) => goTo(event, section.id)}>
                      {section.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2>Acesso</h2>
              <ul>
                <li><a href="/login">Entrar</a></li>
                <li><a href="/register">Criar minha conta</a></li>
                <li><a href="/forgot-password">Recuperar senha</a></li>
              </ul>
            </div>

            <div>
              <h2>Informações</h2>
              <ul>
                <li><a href="/termos-de-uso">Termos de uso</a></li>
                <li><a href="/privacidade">Política de privacidade</a></li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="lp-footer__bottom">
          <span>© {currentYear} PsyAssist Pro. Todos os direitos reservados.</span>
          <span>Feito para a rotina de quem atende.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
